








import Vue from 'vue'
import {ActiveFormError} from './BZCore/ActiveForm'
import {codes} from './BZCore/ActiveFormErrors'

interface IError {
  code: string,
  message: string
}

export default Vue.extend({
  name: 'errors',
  props: {
    error: Array as () => ActiveFormError[]
  },
  computed: {
    errorTexts (): IError[] {
      const errors: IError[] = []
      for (const err of this.error) {
        if (this.errorText(err)) {
          errors.push({code: err.code || '', message: this.errorText(err) as string})
        }
      }
      return errors
    }
  },
  methods: {
    errorText (error: ActiveFormError) {
      if (error.message) {
        return error.message
      }
      if (error.code && codes[error.code] && codes[error.code].message) {
        return codes[error.code].message
      }
      return false
    }
  }
})
